//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import React from 'react';

import { ProductDetailsFieldLabels } from '@campaigns/components/shared/product-details-modal/drawer/constants/ProductDetailsModalFieldLabels';
import { FormField } from '@campaigns/components/shared/product-details-modal/drawer/form/FormField';

interface ProductDescriptionFieldProps {
  isViewOnly: boolean;
}

export const ProductDescriptionField = ({
  isViewOnly,
}: ProductDescriptionFieldProps) => {
  return (
    <FormField
      inputType='textarea'
      isHtml
      isViewOnly={isViewOnly}
      label={ProductDetailsFieldLabels.description}
      name='description'
      placeholder='Describe your product, including key features and benefits.'
      rules={{
        required: {
          value: true,
          message: 'Please enter a product description',
        },
      }}
    />
  );
};
